module.exports = __webpack_public_path__ + "static/img/14.b686d9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/zh/14.png
// module id = gLJU
// module chunks = 0